import { type MantineColor, Text } from "@mantine/core";
import type { JSX } from "react";
import { useEffect } from "react";
import { useTimer } from "react-timer-hook";
import { formatTime } from "@/shared-utils";
import { ChatPreviewBadge } from "./ChatPreviewBadge";
import { ElapsedTimeValue } from "./ElapsedTimeValue";

export const AboutToEnd = ({
    endReason,
    endAt,
    endReasonColor,
}: {
    endReason: string;
    endAt: Date | undefined;
    endReasonColor: MantineColor;
}): JSX.Element => {
    const { totalSeconds, restart } = useTimer({ expiryTimestamp: endAt ?? new Date() });
    const formattedTimeLeft =
        totalSeconds >= 60 ? formatTime(totalSeconds, false) : formatTime(totalSeconds, false, "ss");
    const [timeValue, timeUnit] = formattedTimeLeft.split(" ");

    useEffect(() => {
        if (endAt) {
            restart(endAt);
        }
    }, [endAt, restart]);

    return (
        <>
            <ChatPreviewBadge color={endReasonColor} c="dark.9" leftSection={<Text size="xxs">{endReason}</Text>}>
                {endAt && <ElapsedTimeValue value={timeValue} unit={timeUnit} size="xxs" visibleFrom="md" />}
            </ChatPreviewBadge>
        </>
    );
};
